<template>
    <v-card class="job-side-menu rounded-0 pa-4 py-15" :width="isPadBool ? '100vw' : 350"
        :height="isPadBool ? 'calc(100vh - 56px)' : '100vh'">
        <v-row no-gutters justify="start" align="center" class="job-side-menu__header px-4 py-2 ml-n4"
            :style="'width:' + (isPadBool ? '100vw; min-height: 52px;' : '350px')">
            <v-col cols="auto">
                <h3 class="mb-0 mt-2">{{ $t('partner.job.order') }} {{ job?.Order?.Id }}</h3>
            </v-col>
            <v-spacer></v-spacer>
            <template v-if="isPadBool">
                <v-spacer></v-spacer>
                <v-btn icon="mdi-close" variant="text" class="mr-n2" @click="emitMenuVisibility(!menuVisible)">
                </v-btn>
            </template>
        </v-row>

        <FirstLineCommentNote :comment="job.FirstLineComment">
        </FirstLineCommentNote>

        <ServiceManagerCommentNote :comment="job.ServiceManagerComment">
        </ServiceManagerCommentNote>

        <AppointmentCard v-for="(item, index) in job.Appointments" :key="'apppointment-' + index" :appointment="item">
        </AppointmentCard>

        <TableOfContents v-if="isBatchJob && !isPadBool" :job="job">
            <!-- hid it for non batchjobs as it was overkill -->
        </TableOfContents>

        <Attachments :jobId="job.Id" :job="job" :readonly="isFinalized" @Refresh="$emit('Refresh')">
        </Attachments>

        <v-row no-gutters justify="center" class="job-side-menu__footer ml-n4" style="width: 350px;"
            :style="isPadBool ? 'bottom: 56px;' : 'bottom: 0;'">
            <v-btn v-if="!isFinalized" color="primary" class="complete-btn mx-4 my-3" :loading="statusLoading"
                @click="$emit('setStatus', 'Completed')">
                <v-icon class="mr-2">mdi-check</v-icon>
                {{ $t('partner.job.mark_as_completed') }}
            </v-btn>
            <FinalizedJobBanner v-else class="mx-4 my-3">
            </FinalizedJobBanner>
        </v-row>
    </v-card>
</template>


<script>
import Attachments from "@/components/Cards/Attachments.vue";
import AppointmentCard from "@/components/Cards/AppointmentCard.vue";
import TableOfContents from "@/components/TableOfContents.vue";
import FirstLineCommentNote from "@/components/Cards/FirstLineCommentNote.vue";
import ServiceManagerCommentNote from "@/components/Cards/ServiceManagerCommentNote.vue";
import FinalizedJobBanner from "@/components/Cards/FinalizedJobBanner.vue";

export default {
    name: "JobSideMenu",
    emits: ['update:modelValue', 'update:showMenu', 'change', 'Refresh', 'setStatus'],
    props: {
        modelValue: {
            default: undefined,
        },
        showMenu: {
            default: undefined,
        },
        job: Object,
        statusLoading: Boolean,
    },
    components: {
        Attachments,
        AppointmentCard,
        TableOfContents,
        FirstLineCommentNote,
        ServiceManagerCommentNote,
        FinalizedJobBanner,
    },

    data() {
        return {

        }
    },

    methods: {
        emitMenuVisibility(value) {
            this.$emit('update:modelValue', value);
            this.$emit('update:showMenu', value);
            this.$emit('change', value);
        },
    },

    computed: {
        menuVisible() {
            return this.modelValue ?? this.showMenu ?? false;
        },
        Customer() {
            return this.job?.Customer;
        },

        InverseParent() {
            return this.job?.InverseParent;
        },

        isBatchJob() {
            return this.job?.InverseParent?.length > 1;
        },

        isFinalized() {
            return this.job?.JobStatus.Id >= 50;
        },
    },

    watch: {},
};
</script>


<style lang="css" scoped>
.job-side-menu {
    position: fixed;
    overflow-y: auto;
    z-index: 3;
    border-right: 1px solid #ececec;
}

.job-side-menu__header {
    position: fixed;
    top: 0;
    z-index: 5;
    background-color: #fff;
    min-height: 44px;
}

.job-side-menu__footer {
    position: fixed;
    background-color: #fff;
}

.v-textarea {
    font-size: 0.9em !important;
}

.complete-btn {
    text-transform: none;
    font-weight: 600;
}

</style>